// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"357":"7559e328","447":"7559e328"}[chunkId] + ".chunk.css";
};